import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, LOGO_URL } from "../lib/api";
import { ShieldCheck, Mail, ArrowLeft, CheckCircle } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Une erreur est survenue. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center px-4 py-10">
      <div className="bg-white border border-neutral-200 rounded-2xl p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <img src={LOGO_URL} alt="IMORA" className="h-14 w-14 mx-auto rounded-xl mb-3" />
          <div className="inline-flex items-center gap-2 bg-neutral-900 text-white text-xs font-bold px-3 py-1 rounded-full mb-2">
            <ShieldCheck size={14} /> RÉINITIALISATION DU MOT DE PASSE
          </div>
          <h1 className="font-heading font-black text-2xl tracking-tighter">Mot de passe oublié ?</h1>
          <p className="text-sm text-neutral-500 mt-1">
            Saisissez votre adresse email administrateur. Vous recevrez un lien pour réinitialiser votre mot de passe.
          </p>
        </div>

        {sent ? (
          <div className="text-center py-6">
            <div className="bg-green-50 border border-green-200 rounded-xl p-6 mb-4">
              <CheckCircle className="h-10 w-10 text-green-500 mx-auto mb-3" />
              <p className="font-heading font-bold text-green-800 text-lg">Email envoyé !</p>
              <p className="text-sm text-green-700 mt-1">
                Si l'adresse <strong>{email}</strong> est autorisée, vous allez recevoir un lien de réinitialisation. Vérifiez vos spams.
              </p>
            </div>
            <Link
              to="/admin-login"
              data-testid="back-to-login-btn"
              className="inline-flex items-center gap-2 text-sm font-bold text-[#FF6B1A] hover:underline"
            >
              <ArrowLeft size={14} /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-bold text-neutral-600 uppercase">
                <Mail size={12} className="inline mr-1" /> Adresse email administrateur
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-password-email"
                placeholder="votre@gmail.com"
                className="mt-1 w-full h-12 px-4 border-2 border-neutral-200 rounded-lg focus:border-[#FF6B1A] focus:outline-none text-sm"
              />
            </div>

            {error && (
              <p data-testid="forgot-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full h-12 bg-neutral-900 hover:bg-black text-white font-bold rounded-lg transition disabled:opacity-60"
            >
              {loading ? "Envoi en cours…" : "Envoyer le lien de réinitialisation"}
            </button>

            <div className="text-center">
              <Link
                to="/admin-login"
                data-testid="back-to-admin-link"
                className="inline-flex items-center gap-1 text-sm text-neutral-500 hover:text-neutral-900"
              >
                <ArrowLeft size={13} /> Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
